/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_Q1Inputs */

const en_diff_faq_q1 = /** @type {(inputs: Diff_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are differences displayed?`)
};

const ko_diff_faq_q1 = /** @type {(inputs: Diff_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차이점은 어떻게 표시되나요?`)
};

const ja_diff_faq_q1 = /** @type {(inputs: Diff_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差分はどのように表示されますか？`)
};

/**
* | output |
* | --- |
* | "How are differences displayed?" |
*
* @param {Diff_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_q1 = /** @type {((inputs?: Diff_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_q1(inputs)
	if (locale === "ko") return ko_diff_faq_q1(inputs)
	return ja_diff_faq_q1(inputs)
});